import { render, staticRenderFns } from "./room.vue?vue&type=template&id=4f1eebd3&"
import script from "./room.vue?vue&type=script&lang=ts&"
export * from "./room.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports